import React, { useState } from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import Carousel from '../Subscription/carousel';
import Collapsible from '../Subscription/collapse';
import { Link } from 'react-router-dom';
import { TextField } from '@material-ui/core';
import './Subscription.css';
import { Container } from '@material-ui/core';
import userImage from '../../assets/subscription.png';
import speechTherapyImage from '../../assets/tracker-assets/speech_therapy.png';
import psycologistImage from '../../assets/tracker-assets/psycologist.png';
import pediatricsImage from '../../assets/tracker-assets/pediatrics.png';
import dermatologyImage from '../../assets/tracker-assets/dermatology.png';
import optometristImage from '../../assets/tracker-assets/optometrist.png';
import nutritionCounsellingImage from '../../assets/tracker-assets/nutrition_counselling.png';

const consultationAssets = [
	{ name: 'Speech Therapy', image: speechTherapyImage },
	{ name: 'Psycologist', image: psycologistImage },
	{ name: 'Pediatrics', image: pediatricsImage },
	{ name: 'Dermatology', image: dermatologyImage },
	{ name: 'Optometrist', image: optometristImage },
	{ name: 'Nutrition Counselling', image: nutritionCounsellingImage },
];

const faqList = new Array(3).fill(
	'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Doloremque quas nam laboriosam reiciendis quo amet omnis fugit voluptate aut voluptatem.'
);

const TrackerNavList = [
	'Subscription',
	'Membership Plans',
	'Offers Applied',
	'How it Works',
	'Consultation',
	'FAQs',
	'Ask Query',
];


const Subscription = (props) => {
	const { bearerToken } = props;
	return (
		<div className='subscription-page'>
			<Navbar bearerToken={bearerToken} />
			<div>
				<div className="container-width">
					<div className='subs-nav hide-on-med-and-down'>
						{TrackerNavList.map((aNav) => (
							<p>{aNav}</p>
						))}
					</div>
					<div className='subscription'>
						<h4>Subscription Plan</h4>
					</div>
					<div className='row'>
						<div className='col s12 m6'>
							<div className="subs-plan-card">
								<div className="div1">
									<div className="subs-img">
										<img src={userImage} alt="subscription-image" />
									</div>
									<h6>One Month Subscription</h6>
									<div>
										<ul>
											<li><a href=""><i class="far fa-credit-card icon-bg"></i>Classic</a></li>
											<li><a href=""><i class="far fa-credit-card icon-bg"></i>Silver</a></li>
											<li><a href=""><i class="far fa-credit-card icon-bg"></i>Gold</a></li>

										</ul>

									</div>

								</div>
								<div className="div2">
									<form>
										<div className="row">
											<div className="col m5 s4">
												<p>Name:</p>
												<p>Gender:</p>
												<p>Date of Birth:</p>
												<p>Email:</p>
												<p>Mobile:</p>
											</div>
											<div className="col m7 s8">
												<input id="name" type="text" class="validate" placeholder="name" />
												<select class="browser-default">
													<option value="" disabled selected>Select Gender</option>
													<option value="1">Male</option>
													<option value="2">Female</option>
													<option value="3">Other</option>
												</select>
												<input id="dob" type="text" class="validate" />
												<input id="email" type="text" class="validate" placeholder="abc@gmail.com" />
												<input id="mobile" type="text" class="validate" placeholder="+91 9999999999" />

											</div>
										</div>
									</form>
									<div className="center">
										<ul>
											<li>Membership: &nbsp;</li>
											<li><a href=""><i class="far fa-credit-card icon-bg"></i>Classic</a></li>
											<li><a href=""><i class="far fa-credit-card icon-bg"></i>Silver</a></li>
											<li><a href=""><i class="far fa-credit-card icon-bg"></i>Gold</a></li>

										</ul>
										<Link to=""><button class="subs-btn">Subscribe</button></Link>
									</div>
								</div>

							</div>
						</div>
						<div className='col s12 m6'>
							<div className="subs-plan-card">
								<div className="div1">
									<div className="subs-img">
										<img src={userImage} alt="subscription-image" />
									</div>
									<h6>One Month Subscription</h6>
									<div>
										<ul>
										<li><a href=""><i class="far fa-credit-card icon-bg"></i>Classic</a></li>
											<li><a href=""><i class="far fa-credit-card icon-bg"></i>Silver</a></li>
											<li><a href=""><i class="far fa-credit-card icon-bg"></i>Gold</a></li>

										</ul>

									</div>

								</div>
								<div className="div2">
									<form>
										<div className="row">
											<div className="col m5 s4">
												<p>Name:</p>
												<p>Gender:</p>
												<p>Date of Birth:</p>
												<p>Email:</p>
												<p>Mobile:</p>
											</div>
											<div className="col m7 s8">
												<input id="name" type="text" class="validate" placeholder="name" />
												<select class="browser-default">
													<option value="" disabled selected>Select Gender</option>
													<option value="1">Male</option>
													<option value="2">Female</option>
													<option value="3">Other</option>
												</select>
												<input id="dob" type="text" class="validate" />
												<input id="email" type="text" class="validate" placeholder="abc@gmail.com" />
												<input id="mobile" type="text" class="validate" placeholder="+91 9999999999" />

											</div>
										</div>
									</form>
									<div className="center">
										<ul>
											<li>Membership: &nbsp;</li>
											<li><a href=""><i class="far fa-credit-card icon-bg"></i>Classic</a></li>
											<li><a href=""><i class="far fa-credit-card icon-bg"></i>Silver</a></li>
											<li><a href=""><i class="far fa-credit-card icon-bg"></i>Gold</a></li>

										</ul>
										<Link to=""><button class="subs-btn">Subscribe</button></Link>
									</div>
								</div>

							</div>
						</div>
					</div>
					<br />
					<h4>Membership Plan</h4>
				</div>


				<div className="slider-bg">
					<div className="container-width">
						<div className="row">
							<Carousel />
						</div>

					</div>
				</div>
				<br />
				<div className="container">
					<div className="collapse-section">
						<h4>Offer Applied</h4>
						<br />
						<Collapsible />
					</div>
					<br />
					<div className="hwt-section">
						<h4>How it Works</h4>
						<br /><br />
						<div class="step">
							<div>
								<div class="circle"><i class="fas fa-2x fa-hand-point-up"></i></div>
							</div>
							<div>
								<div class="title">Select a plan that works for you or buy  one recommended by our  experts. Select a plan that works for you or buy  one recommended by our  experts.</div>
							</div>
						</div>
						<div class="step step-active">
							<div>
								<div class="circle"><i class="fas fa-2x fa-calendar-check"></i></div>
							</div>
							<div>
								<div class="title">Set improve  targets in consultation with experts</div>
							</div>
						</div>
						<div class="step">
							<div>
								<div class="circle"><i class="fas fa-2x fa-heartbeat"></i></div>
							</div>
							<div>
								<div class="title">Track and review progress through periodic consultations. Select a plan that works for you or buy  one recommended by our  experts.</div>

							</div>
						</div>
						<div class="step">
							<div>
								<div class="circle"><i class="fas fa-2x fa-clipboard-list"></i></div>
							</div>
							<div>
								<div class="title">Chat with experts on app</div>
							</div>
						</div>
					</div>

				</div>
				<br /><br />
				<div className="container">

					<div className='consultation'>
						<h4>Consultation</h4>
						<br />
						<div className='row'>
							{consultationAssets.map((anAsset) => (
								<div className='col s12 m4'>
									<img src={anAsset.image} />
									<p>{anAsset.name}</p>
								</div>
							))}
						</div>
					</div>
					<br /><br />
					<div className='faqs'>

						<h4>FAQs:</h4>
						<br />
						{faqList.map((aFaq) => (
							<p>{aFaq}</p>
						))}
					</div>
					<br /><br />
					<div className='ask-query'>
						<h4>Ask Query: </h4>
						<br />
						<textarea className='browser-default' placeholder='Your Message' />
						<div>
							<p>your contact information</p>
							<input type='text' placeholder='First Name' className='browser-default' />
							<input type='text' placeholder='Last Name' className='browser-default' />
							<p>How would you like us to get in touch with you ?</p>
							<input type='text' placeholder='Email' className='browser-default' />
							<input type='text' placeholder='Email Address' className='browser-default' />

							<input type='text' placeholder='India(+91)' className='browser-default' />
							<input type='text' placeholder='Phone' className='browser-default' />
							<p>Country</p>
							<input type='text' placeholder='Country' className='browser-default' />
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</div>
	);
};




export default Subscription;
